<template>
    <div
        class="user-select-none rounded color-row"
        :class="classColor"
    >
        &nbsp;
    </div>
</template>

<script>
export default {
    name: 'EventStatus',

    props: {
        value: {
            type: String,
            'default': '',
        },

        circle: {
            type: Boolean,
            'default': false,
        },
    },

    data() {
        return {
            statusVariant: {
                pending: 'light',
                ready: 'secondary',
                queue: 'purple',
                process: 'info',
                done: 'success',
                fail: 'warning',
                canceled: 'dark',
                waiting: 'primary',
            },
        };
    },

    computed: {
        classColor: vm => 'bg-' +
            (vm.statusVariant[vm.value] || 'light') +
            (vm.circle ? ' p-1 rounded-circle around' : ''),
    },
};
</script>

<style lang="scss" scoped>
.color-row {
    line-height: 2.5em;
    width: 3px;
}

.around {
    margin-top: 0.6em;
    width: 10px;
    height: 10px;
}
</style>